import React, { useState, useEffect } from 'react';
import parse from "html-react-parser"
import List from "../Page/List"
import Store from "../Store/Store"
import { formatMoney } from "../utilities/utilities"

export default function Cabins( props ) {

	const c = props.cruise

	const cabinsList = [
		{
			id:"cabin_master",
			title:"Master Cabin",
			specification:"double bed + bathroom",
			price:c.price_master, 
		},{
			id:"cabin_vip",
			title:"VIP Cabin",
			specification:"double bed + bathroom",
			price:c.price_vip, 
		},{
			id:"cabin_standard",
			title:"Regular Cabin",
			specification:"2 single beds + bathroom",
			price:c.price_standard, 
		},{
			id:"cabin_bunk",
			title:"Regular Bunk Cabin",
			specification:"2 single beds, 1 bunk bead + bathroom",
			price:c.price_bunk, 
		}
	]

	useEffect(() => {
		let total = 0
		cabinsList.forEach( a => {
			if ( props.cabins[ a.id ] === 't' ) total += Number( a.price )
		} )
		props.setTotal( total )
	}, [ props.tmp ] )
	
	if ( !c ) return null

	return <>
		{ cabinsList.map( ( a, i ) => {
			return <div 
				key={ a.id } 
				onClick={ e => { 
					const t = props.cabins
					t[ a.id ] = t[ a.id ] === 'f' ? 't' : 'f'
					props.setCabins( t ) 
					//Store.set( a.id, t )
					props.setTmp( props.tmp + 1 )
				} }
				style={{ 
					padding:'5px 10px', marginBottom:10, 
					border:props.cabins[ a.id ] === 't' ? '1px solid #777' : '1px solid #ccc', 
					borderRadius:10, 
					background:props.cabins[ a.id ] === 't' ? '#ddd' : '#fff',
					cursor:'pointer', userSelect:'none',
				}} 
			>
				<div style={{ fontSize:14, fontWeight:700 }} >
					{ a.title }
				</div>
				<div style={{ fontSize:14 }} >
					{ a.specification }
				</div>
				<div style={{ fontSize:14, fontWeight:500 }} >
					{ formatMoney( a.price, 0, 'en-US' ) } ({ formatMoney( a.price / 2, 0, 'en-US' ) } per person)
				</div>
			</div>
		} ) }
		<div>
			Total Price <span style={{ fontWeight:700 }} >{ formatMoney( props.total, 0, 'en-US' ) }</span>
		</div>
	</>
}
